/** @format */
import angular from 'angular';
import { configModule } from '../config/config.module';
import { commonUniversityServiceModule } from '../university/university.service';
import { authServiceModule } from './auth.service';

export const authModule = 'sis-common.auth';

(function () {
    angular.module(authModule, [configModule, commonUniversityServiceModule, authServiceModule]);
})();
